import {Action, openDialog, Tabs, TabProps} from 'platform/components';
import {Box, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';
import {usePermissions} from '@dms/shared';

import {buildArray, suffixTestId, TestIdProps} from 'shared/web';

import {ReceivingMailboxesSection} from './ReceivingMailboxesSection';
import {SyncedMessagesDatagrid} from './SyncedMessagesDatagrid';

export function SyncedMessages(props: TestIdProps) {
  const [canReadTenantMailbox] = usePermissions({permissionKeys: ['tenantMailboxRead']});

  const handleOpenMailboxes = () =>
    openDialog(<ReceivingMailboxesSection />, {
      title: i18n.t('page.myProfile.receivingMailbox.sectionTitle'),
    });

  const mailboxesActions: Action[] = [
    {
      type: 'button',
      variant: 'secondary',
      leftIcon: 'communication/email',
      title: i18n.t('page.myProfile.receivingMailbox.sectionTitle'),
      onClick: handleOpenMailboxes,
      'data-testid': suffixTestId('syncedMessages-mailboxes', props),
    },
  ];

  const tabs = buildArray<TabProps>()
    .add({
      id: 'user',
      title: i18n.t('page.myProfile.receivedMessages.tabs.myMessages'),
      actions: mailboxesActions,
      content: (
        <Box height="100%" width="100%">
          <SyncedMessagesDatagrid
            gridCode="messaging-user-synced-message"
            data-testid={suffixTestId('syncedMessages-user', props)}
          />
        </Box>
      ),
      'data-testid': suffixTestId('syncedMessages-tab-user', props),
    })
    .when(canReadTenantMailbox, {
      id: 'tenant',
      title: i18n.t('page.myProfile.receivedMessages.tabs.sharedMessages'),
      actions: mailboxesActions,
      content: (
        <Box height="100%" width="100%">
          <SyncedMessagesDatagrid
            gridCode="messaging-tenant-synced-message"
            data-testid={suffixTestId('syncedMessages-tenant', props)}
          />
        </Box>
      ),
      'data-testid': suffixTestId('syncedMessages-tab-tenant', props),
    });

  return (
    <VStack height="100%" grow={1}>
      <Tabs
        variant="fullHeight"
        isFullHeight
        isLazy
        lazyBehavior="keepMounted"
        tabs={tabs}
        data-testid={suffixTestId('syncedMessages-tabs', props)}
      />
    </VStack>
  );
}
